import 'forms6/polyfill.js'
import Form from 'forms6/Form.js'
import '../forms6/scss/app-ms4'

const form = new Form('#manetform_v6');
form.init();